<template>
  <v-data-table
    :items="services"
    :headers="headers"
    hide-default-footer
    :items-per-page="-1"
    :loading="!services || services.length === 0"
  >
    <template #[`item.title`]="{ item }">
      <span v-if="item.api_only">{{ item.title }}</span>
      <b-link
        v-else-if="!item.url || !(item.url.startsWith('http') || item.url.endsWith('.html'))"
        :to="item.url || `/${item.name}`"
        :target="item.target || '_self'"
      >
        {{ item.title }}
      </b-link>
      <a
        v-else
        :href="item.url"
        :target="item.target || '_self'"
      >
        {{ item.title }}
      </a>
    </template>

    <template #[`item.api`]="{ item }">
      <a
        v-if="!item.api || item.api !== 'hidden'"
        :href="item.api || `/api/${item.name}/swagger`"
        target="_blank"
      >
        {{ item.title }} module API
      </a>
    </template>

    <template #[`item.is_available`]="{ item }">
      <template v-if="item.is_available !== undefined">
        <span
          v-if="item.is_available"
          class="dot green-dot"
          v-b-tooltip
          title="Module is available"
        />
        <span
          v-else
          class="dot red-dot"
          v-b-tooltip
          title="Module is not available"
        />
      </template>
    </template>

    <template #[`item.build_date`]="{ item }">
      <template v-if="item.build_date">
        <span
          v-if="item.build_date.includes('</a>')"
          v-html="item.build_date"
        />
        <span v-else>{{ formatDate(item.build_date) }}</span>
      </template>
    </template>

    <template #[`item.description`]="{ item }">
      <template v-if="item.description">
        <span
          v-if="item.description.includes('</a>')"
          v-html="item.description"
        />
        <span v-else>{{ item.description }}</span>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment/moment'

export default {
  data() {
    return {
      DATE_FORMAT: 'YYYY-MM-DD HH:mm',
    }
  },
  props: {
    headers: {},
    services: {},
  },
  methods: {
    formatDate(value) {
      if (!value.includes('T')) {
        return value
      }
      const date = moment(value)
      if (date.isValid()) {
        return date.format(this.DATE_FORMAT)
      } else {
        return null
      }
    },
  },
}
</script>

<style scoped>
.dot {
  display: inline-block;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid #e1e1e1;
}

.red-dot {
  background-color: red;
}

.green-dot {
  background-color: #45e66e;
}

.v-data-table ::v-deep td:has(.dot) {
  text-align: center !important;
}
</style>
